import React from 'react';
import Footer from './footer';
import '../../layout.scss'
import {GatsbyImage} from "gatsby-plugin-image"
import {graphql, Link, useStaticQuery} from "gatsby";
import {Helmet} from 'react-helmet';

const Layout: React.FC = ({ children }) => {
  const {file} = useStaticQuery(query);
  return (
    <>
        <Helmet htmlAttributes={{ lang: 'de' }}>
            <title>Sebastian Klaus - Softwareentwicklung und Beratung | Share a password</title>
            <meta charSet="utf-8" />
            <meta name="description" content="Sebastian Klaus - Softwareentwicklung und Beratung | Share a password a tool to securely exchange secrets" />
        </Helmet>
        <div className="menu">
            <header>
                <Link to="/"><GatsbyImage image={file.childImageSharp.gatsbyImageData}  alt="Sebastian Klaus - Softwareentwicklung und Beratung"/></Link>
                <h1>Share a Secret</h1>
            </header>
        </div>
        <main><div className="content">{children}</div></main>
      <Footer />
    </>
  );
};

const query = graphql`
query Layout {
  file(relativePath: {eq: "logo-white.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FIXED, height: 80)
    }
  }
}
`;

export default Layout;
